// Composable für Lieblings-Ligen - im localStorage gespeichert, bleibt über Seiten-Neuladen
// erhalten. Eigenes Composable statt useFavoriten (Team-Favoriten) mitzubenutzen, weil beides
// inhaltlich unterschiedliche Dinge sind (Liga-Keys vs. Team-IDs) und getrennt gespeichert werden
// soll.
import { ref, watch } from 'vue'

const SPEICHER_SCHLUESSEL = 'tm-spielplan-liga-favoriten'

function ladeLigaFavoriten() {
  try {
    const roh = localStorage.getItem(SPEICHER_SCHLUESSEL)
    return roh ? new Set(JSON.parse(roh)) : new Set()
  } catch {
    return new Set()
  }
}

// State auf Modul-Ebene - geteilt über alle Aufrufer (siehe useFavoriten.js für die
// ausführliche Begründung, warum das nicht innerhalb der Funktion stehen darf).
const ligaFavoriten = ref(ladeLigaFavoriten())

watch(ligaFavoriten, (neu) => {
  try {
    localStorage.setItem(SPEICHER_SCHLUESSEL, JSON.stringify([...neu]))
  } catch {
    // ignorieren, falls Speichern fehlschlägt (z.B. Safari privater Modus)
  }
}, { deep: true })

export function useLigaFavoriten() {
  function istLigaFavorit(ligaKey) {
    return ligaKey != null && ligaFavoriten.value.has(ligaKey)
  }

  function toggleLigaFavorit(ligaKey) {
    if (ligaKey == null) return
    if (ligaFavoriten.value.has(ligaKey)) ligaFavoriten.value.delete(ligaKey)
    else ligaFavoriten.value.add(ligaKey)
  }

  return { ligaFavoriten, istLigaFavorit, toggleLigaFavorit }
}